import "./SeasonalCollections.module.css";
import Navigation from "@/reusable_sections/Header";
import Collection from "./sections/Collection";
import Category from "./sections/Category";
import Footer from "@/reusable_sections/Footer";
export default function SeasonalCollectionsPage() {
  return <div>
      <Navigation />
      <Collection />
      <Category />
      <Footer />
    </div>;
}